import { Alert, IAction } from '@/components/common/alert';

import { TOptions } from 'i18next';
import { isNotUndefined } from 'ramda-adjunct';

import { NOOP } from './common.util';

export const showAlert = (
	title: string,
	onNext?: () => void,
	onCancel?: () => void,
	options?: {
		isShowCloseIcon?: boolean;
		cancelText?: string;
		confirmText?: string;
		delay?: number;
		isShowFooter?: boolean;
		hideDivide?: boolean;
		message?: string;
		messageOptions?: TOptions;
		countdownMs?: number;
	}
) => {
	const actions: IAction[] = isNotUndefined(onCancel)
		? [
				{
					text: options?.cancelText ?? 'cancel',
					onClick: () => {
						onCancel?.();
					},
					style: 'cancel',
				},
				{
					text: options?.confirmText ?? 'confirm',
					onClick: onNext ?? NOOP,
					style: 'next',
				},
			]
		: [
				{
					text: options?.confirmText ?? 'confirm',
					onClick: onNext ?? NOOP,
					style: 'next',
				},
			];

	Alert.alert(title, options?.message, actions, {
		closeWhenClickOutside: false,
		...options,
	});
};
